export interface DeleteMyAccount {
  unenrollProgramsStatus: number | null;
  deleteMyAccountStatus: number | null;
  sendTemplatedEmailStatus: number | null;
}

export interface DeleteMyAccountStatusObject {
  code?: number;
}

export type DeleteMyAccountStatus = number | DeleteMyAccountStatusObject;

export interface DeleteMyAccountResponse {
  status: DeleteMyAccountStatus;
}

export interface UnenrollProgramsMessage {
  code: number;
  status: number;
}

export interface UnenrollProgramsResponse {
  status: {
    code: number;
    messages: UnenrollProgramsMessage[];
  };
}

export const initialState: DeleteMyAccount = {
  unenrollProgramsStatus: null,
  deleteMyAccountStatus: null,
  sendTemplatedEmailStatus: null
};
